import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import './index.css';
import './css/semantic.css';
import './css/portal.css';
import './css/CPTA_changes.css';
import App from './App';
import { OidcProvider } from './auth/oidc.tsx';

// import 'semantic-ui-css/semantic.min.css'
const queryClient = new QueryClient();
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <OidcProvider>
        <App />
      </OidcProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
